import { render, staticRenderFns } from "./VacancyPresetsList.vue?vue&type=template&id=569d98c9&scoped=true&"
import script from "./VacancyPresetsList.vue?vue&type=script&lang=js&"
export * from "./VacancyPresetsList.vue?vue&type=script&lang=js&"
import style0 from "./VacancyPresetsList.vue?vue&type=style&index=0&id=569d98c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d98c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
